import { render, staticRenderFns } from "./Retailers.vue?vue&type=template&id=10d114a8"
import script from "./Retailers.vue?vue&type=script&lang=js"
export * from "./Retailers.vue?vue&type=script&lang=js"
import style0 from "./Retailers.vue?vue&type=style&index=0&id=10d114a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports